module.exports = __webpack_public_path__ + "static/media/gros_oeuvre.38610a20.png";